export const LandingServiceID = {
  RootStore: Symbol.for("LandingRootStore"),
  SessionStore: Symbol.for("LandingSessionStore"),
  Timer: Symbol.for("LandingTimer"),
  CoachStore: Symbol.for("LandingCoachStore"),
  QueryClientFactory: Symbol.for("LandingQueryClientFactory"),
  QueryClient: Symbol.for("LandingQueryClient"),
  DemoDeviceCheckStore: Symbol.for("DemoDeviceCheckStore"),
  DemoClockStore: Symbol.for("DemoClockStore"),
  DemoSignalsStore: Symbol.for("DemoSignalsStore"),
  DemoRecapStore: Symbol.for("DemoRecapStore"),
  DemoCallControlStore: Symbol.for("DemoCallControlStore"),
};
